<div class="chart-fullscreen-dialog" [attr.aria-labelledby]="'dialog-title'">
  <div class="dialog-header">
    <h2 id="dialog-title" class="dialog-title">{{ data.title }}</h2>
    <div class="dialog-actions">
      <mat-icon
        *ngIf="data.tooltip"
        class="info-icon"
        [matTooltip]="data.tooltip">info_outline</mat-icon>
      <button
        mat-icon-button
        (click)="fechar()"
        aria-label="Fechar visualização ampliada">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="dialog-content">
    <div class="dialog-chart-container">
      <canvas
        baseChart
        [data]="data.chartData"
        [options]="data.chartOptions"
        [type]="data.chartType">
      </canvas>
    </div>
  </div>
</div>
